module.exports = __webpack_public_path__ + "static/block1-21fc1490662bed37022b89cdececaf7f.jpg";